// extracted by mini-css-extract-plugin
export var pageContainer = "_i-1";
export var settingsContent = "_i-0";